export default __webpack_public_path__ + "static/media/Close_gd.ca285eb5.svg";